import { markups } from "../../markups.js";
import { packPrice } from "./packs.js";
import { printPrice } from "./prints.js";

function totalMarkupsPercent(state) {
  return state.markups.reduce(
    (sum, idx) => sum + (markups[idx]?.percent ?? 0),
    0
  );
}

export function totalPrice(state) {
  /*
   * T  — тираж (количество пакетов)
   * B  — цена одного пакета
   * N1 — цветов на лице
   * N2 — цветов на обороте
   * Q  — общее число оттисков
   * P  — цена одного оттиска (от Q, не от T)
   * O  — наценка за разные макеты
   * M  — коэффициент наценок
   */
  const T = state.quantity || state.quantity_manual;
  const B = packPrice(state.density, state.size, state.color);
  const N1 = state.face_colors;
  const N2 = state.rear_colors;

  if (!B || !T) return 0;             // защита от undefined

  const Q = T * (N1 + N2);
  const P = printPrice(state.size, Q) ?? 0;
  const O = state.same_print ? 0 : (N1 + N2 - 1) * 1000;
  const PRICE = T * (B + P * (N1 + N2)) + O;
  const M = (100 + totalMarkupsPercent(state)) / 100;

  return Math.floor(PRICE * M);
}
